import { useMutation } from 'react-query';
import client from 'client';
import { SessionRating } from './type';

const useRateSession = (eventId: number, sessionId: number) => {
    const rateSessionMutation = useMutation({
        mutationFn: (rating: Partial<SessionRating>) => {
            return client().put(
                `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/rate`,
                rating
            );
        },
    });

    return rateSessionMutation;
};

export default useRateSession;
